export default {
    400: {
        title: "Špatný požadavek",
        header: "@:views.errors.400.title",
        html: "Špatný požadavek. Zkuste to prosím znovu později."
    },
    401: {
        title: "Při přihlašování došlo k chybě",
        header: "@:views.errors.401.title",
        html: "Kontaktujte prosím <a href='{email}' target='_blank'>podporu</a> ."
    },
    404: {
        title: "Stránka nenalezena",
        header: "@:views.errors.404.title"
    },
    403: {
        title: "Přístup není povolen",
        header: "Přístup není povolen",

        contact: "O-I Periferní zařízení je k dispozici pouze zaměstnancům. Pokud jste zaměstnancem a vidíte tuto zprávu, obraťte se prosím na místní oddělení People &amp; Culture a aktualizujte svůj stav.",

        subject: "Výbava - Způsobilost",

        html: "<p class='text-start'> @:views.errors.403.contact</p>",
        error: {
            disabled: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Momentálně nesplňujete podmínky. Pro více informací kontaktujte <a href='#' role='button' data-widget-trigger='{widgetOptions}'>podporu</a> .</p>"
            },
            "not-active": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Momentálně nesplňujete podmínky. Pro více informací se prosím obraťte na místní oddělení People &amp; Culture.</p>"
            },
            "not-allowed":{
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I Periferní zařízení je k dispozici pouze zaměstnancům. Pokud jste zaměstnancem a vidíte tuto zprávu, obraťte se prosím na místní oddělení People &amp; Culture a aktualizujte svůj stav.</p>"
            },
            "no-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Ve vašem profilu ServiceNow není uveden žádný aktivní manažer. Pro aktualizaci informací o vašem manažerovi se prosím obraťte na svého místního zástupce pro lidské zdroje a kulturu.</p>"
            },
            "self-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Ve vašem profilu ServiceNow je váš manažer nastaven jako vy. Pro aktualizaci vašeho manažera se prosím obraťte na svého místního zástupce pro lidské zdroje a kulturu.</p>"
            },
            "no-location": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Ve svém profilu ServiceNow nemáte uvedenou žádnou pobočku. Pro aktualizaci vaší pobočky se prosím obraťte na svého místního zástupce pro lidi a kulturu.</p>"
            },
            eligibility: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I Periferní zařízení je k dispozici pouze zaměstnancům. Pokud jste zaměstnancem a vidíte tuto zprávu, obraťte se prosím na místní oddělení People &amp; Culture, kde aktualizujete svůj stav.</p>",
            },
            "eligibility-location": {
                header: "",
                html: "Děkujeme za váš zájem o program O-I Peripheral. V současné době není tento program ve vaší zemi k dispozici.",
            },
            "secondary-account": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Momentálně se pokoušíte o přístup k periferii O-I na sekundárním účtu. Zkuste se prosím znovu přihlásit pomocí svého primárního účtu.</p>"
            },
            "empty-core-id": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Váš účet ServiceNow nemá název účtu. Pro aktualizaci účtu se prosím obraťte na svého místního zástupce oddělení People &amp; Culture.</p>"
            },
            country: {
                header: "@:views.errors.403.header",
                html: " @:views.errors.403.contact",
            },
            "no-permissions": {
                header: "Bez přístupu",
                subject: "Bez přístupu",
                html: "Nemáte oprávnění k otevření této stránky.",
            },
            "virtual-denied": {
                header: "Vypadá to, že jsi trochu brzy...",
                html: "<p class='text-start'>Děkujeme za váš zájem o O-I Peripheral. Zdá se, že jste se na web dostali předtím, než jste byli aktivováni a přímo pozváni. O-I Peripheral je zaváděn postupně, v jednotlivých zemích a skupinách uživatelů. Po aktivaci obdržíte e-mail s osobní pozvánkou a pokyny.</p><p class='text-start'> V případě dotazů nebo problémů s objednávkou nebo webem klikněte na <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Podpora</a> .</p>",
            }
        }
    },
    500: {
        title: "Neočekávaná chyba",
        header: "@:views.errors.500.title",
        message: "Došlo k chybě. Zkuste to prosím znovu později."
    },
    code: {
        title: "Neočekávaná chyba",
        message: "@:views.errors.code.title",
        error: "Chyba {code}."
    }
}